// src/components/DifferencePyramid.js
import React from "react";
import { locales } from "../../locales";
import { formatNumber } from "../../utils/communesUtils";

const DifferencePyramid = ({ data, langId }) => {
  const newData = data;
  const maxValue = Math.max(
    ...Object.values(newData).map((obj) => Math.max(obj.gain, obj.lost))
  );
  const barHeight = 30;
  const maxBarWidth = 280;

  return (
    <div className="flex flex-col">
      <div className="flex flex-row justify-center mb-[5px]">
        <div className="w-[328px] mr-2 flex justify-end items-center">
          <span className="text-xs font-bold leading-[16.8px]">
            {locales[langId].lostVotes}
          </span>
        </div>
        <div className="w-[250px] flex justify-start items-center">
          <span className="text-xs font-semibold leading-[16.8px]">
            {locales[langId].gainedVotes}
          </span>
        </div>
      </div>
      {Object.entries(newData).map(([ageRange, { gain, lost }]) => (
        <div key={ageRange} className="flex">
          <div className="flex items-center justify-start w-[90px]">
            <span className="text-xs font-bold leading-[14px]">{ageRange}</span>
          </div>
          <div className="flex items-center justify-center h-[30px] bg-wort-background mb-2 w-full">
            <div className="flex items-center justify-end w-1/2 mr-2">
              <div
                className="bg-[#E88B00] flex items-center justify-end pr-2"
                style={{
                  height: `${barHeight}px`,
                  width: `${((lost / maxValue) * maxBarWidth) / 2}px`,
                  minWidth: "20px",
                }}
              >
                <span>{formatNumber(newData[ageRange].lost)}</span>
              </div>
            </div>
            <div className="flex items-center justify-start w-1/2">
              <div
                className="bg-[#86CDEB] flex items-center justify-start pl-2"
                style={{
                  height: `${barHeight}px`,
                  width: `${((gain / maxValue) * maxBarWidth) / 2}px`,
                  minWidth: "20px",
                }}
              >
                <span>{formatNumber(newData[ageRange].gain)}</span>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default DifferencePyramid;
